import { calculateLineHeight } from '../utils'

const UNDERLINE_WIDTH = 1
const UNDERLINE_SHIFT = 6

export default class TextRule {
  constructor(text) {
    this.x = 0
    this.y = 0
    this.text = text
    this.parent = null
    this.width = null
    this.font = null
    this.fontSize = 0
    this.lineHeight = 0
  }

  getType() {}

  getWidth() {
    throw new Error('No implementation for getWidth')
  }

  setStyle(style) {
    if (this.font === style.font) {
      return
    }
    this.width = null
    this.font = style.font
    this.fontSize = style.fontSize.value
    this.lineHeight = calculateLineHeight(style)
  }

  setParent(parent) {
    this.parent = parent
  }

  drawDecoration(ctx) {
    if (ctx.textDecoration === 'underline') {
      ctx.fillRect(
        this.x,
        this.y + this.fontSize + UNDERLINE_SHIFT,
        this.getWidth(),
        UNDERLINE_WIDTH,
      )
    }
  }
}
